function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function SvgPillIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D527C"
    },
    d: "M252.293,432.283c-26.896,0-52.118-10.41-71.02-29.311L29.369,251.069 c-39.159-39.16-39.159-102.879,0-142.04c18.902-18.902,44.124-29.313,71.02-29.313s52.118,10.41,71.02,29.313l24.37,24.37 c5.135,5.135,5.136,13.461,0,18.596s-13.461,5.136-18.596,0l-24.371-24.37c-13.934-13.936-32.553-21.61-52.424-21.61 s-38.49,7.674-52.423,21.608c-28.906,28.906-28.906,75.94,0,104.848l151.903,151.903c13.936,13.936,32.553,21.61,52.424,21.61 s38.488-7.674,52.423-21.608c28.906-28.906,28.906-75.94,0-104.847c-5.135-5.135-5.135-13.461,0-18.597 c5.136-5.135,13.46-5.135,18.597,0c18.901,18.902,29.311,44.124,29.311,71.02c0,26.896-10.41,52.118-29.311,71.02 C304.411,421.873,279.189,432.283,252.293,432.283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D527C"
    },
    d: "M189.359,315.175c-3.365,0-6.731-1.283-9.298-3.851c-5.135-5.135-5.135-13.461,0-18.597 l33.009-33.009c5.135-5.135,13.461-5.135,18.597,0c5.135,5.135,5.135,13.461,0,18.597l-33.009,33.009 C196.089,313.892,192.724,315.175,189.359,315.175z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D527C"
    },
    d: "M130.316,256.133c-3.365,0-6.73-1.283-9.298-3.851c-5.135-5.135-5.136-13.461,0-18.596 l33.008-33.009c5.135-5.135,13.461-5.136,18.596,0c5.135,5.136,5.136,13.461,0,18.596l-33.008,33.009 C137.047,254.848,133.681,256.133,130.316,256.133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D527C"
    },
    d: "M259.766,432.341c-25.72,0-51.44-9.79-71.02-29.369c-39.16-39.16-39.16-102.879,0-142.04 L340.649,109.03c39.16-39.159,102.879-39.16,142.041,0c18.901,18.902,29.311,44.124,29.311,71.02s-10.41,52.118-29.311,71.02 l-24.37,24.37c-5.136,5.136-13.46,5.136-18.597,0c-5.135-5.135-5.135-13.461,0-18.596l24.37-24.37 c28.906-28.906,28.906-75.94,0-104.847c-28.905-28.906-75.942-28.904-104.847,0L207.342,279.528 c-28.906,28.906-28.906,75.94,0,104.847c28.905,28.905,75.94,28.908,104.847,0c5.136-5.136,13.46-5.136,18.597,0 c5.135,5.135,5.135,13.461,0,18.596C311.205,422.552,285.486,432.341,259.766,432.341z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CEE8FA"
    },
    d: "M275.466,192.81l-77.421,77.421c-33.946,33.946-33.946,89.496,0,123.442l0,0 c33.946,33.946,89.496,33.946,123.442,0l77.422-77.421L275.466,192.81z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D527C"
    },
    d: "M259.766,432.283c-26.896,0-52.118-10.41-71.02-29.311c-39.16-39.16-39.16-102.879,0-142.04 l77.421-77.422c5.136-5.135,13.46-5.135,18.597,0l123.444,123.442c2.466,2.466,3.851,5.811,3.851,9.298 c0,3.487-1.386,6.832-3.851,9.298l-77.422,77.421C311.884,421.873,286.662,432.283,259.766,432.283z M275.466,211.405 l-68.123,68.124c-28.906,28.906-28.906,75.94,0,104.847c13.934,13.934,32.553,21.608,52.424,21.608 c19.87,0,38.49-7.674,52.423-21.608l68.124-68.124L275.466,211.405z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D527C"
    },
    d: "M322.699,315.175c-3.366,0-6.73-1.283-9.298-3.851l-33.008-33.009 c-5.135-5.135-5.135-13.461,0-18.596c5.139-5.134,13.462-5.135,18.597,0l33.008,33.009c5.135,5.135,5.135,13.461,0,18.596 C329.43,313.892,326.064,315.175,322.699,315.175z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D527C"
    },
    d: "M381.744,256.133c-3.366,0-6.73-1.283-9.298-3.851l-33.009-33.009 c-5.135-5.135-5.135-13.461,0-18.597c5.136-5.135,13.46-5.135,18.597,0l33.009,33.009c5.135,5.135,5.135,13.461,0,18.597 C388.473,254.85,385.108,256.133,381.744,256.133z"
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPillIcon);
export default __webpack_public_path__ + "static/media/pill-icon.43977e12.svg";
export { ForwardRef as ReactComponent };